import { AbstractComponent } from "appworks/components/abstract-component";
import { Sprite } from "appworks/graphics/pixi/sprite";
import { Contract } from "appworks/utils/contracts/contract";
import { Tween } from "appworks/utils/tween";
import { gameLayers } from "game-layers";
import { Container } from "pixi.js";

export class DMFNightModeComponent extends AbstractComponent {

    protected nightContainer: Container;
    protected dayContainer: Container;
    protected nightFrame: Sprite;
    protected dayFrame: Sprite;

    constructor() {
        super();

        gameLayers.MatrixForeground.onSceneEnter.add((scene: string) => {
            if (scene === "default") {
                this.setup();
            }
        });
    }

    public nightMode(night: boolean = true, fadeDuration: number = 500): Contract<void> {
        return new Contract<void>((resolve: (value?: any) => void) => {
            new Tween(this.dayContainer)
            .to({alpha: Number(!night)}, fadeDuration)
            .start();

            new Tween(this.dayFrame)
            .to({alpha: Number(!night)}, fadeDuration)
            .onComplete(resolve)
            .start();
        });
    }

    protected setup(): void {
        this.nightFrame = gameLayers.MatrixForeground.elements.default.fs_frame;
        gameLayers.MatrixForeground.add(this.nightContainer = new Container());
        ["fs_jp_1_2", "fs_jp_3_4", "fs_mini", "fs_minor", "fs_major", "fs_grand"].forEach((name: string) => {
            this.nightContainer.addChild(gameLayers.MatrixForeground.elements.default[name]);
        });

        this.dayFrame = gameLayers.MatrixForeground.elements.default.bg_frame;
        gameLayers.MatrixForeground.add(this.dayContainer = new Container());
        ["bg_jp_1_2", "bg_jp_3_4", "bg_mini", "bg_minor", "bg_major", "bg_grand"].forEach((name: string) => {
            this.dayContainer.addChild(gameLayers.MatrixForeground.elements.default[name]);
        });
    }
}
